





































































































































































































import { formatCurrency } from "@/lib/utility/currency-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IInvoiceLine, InvoiceLine } from "@/models/invoice-line.entity";
import { IInvoice } from "@/models/invoice.entity";
import { AccountingTypeEnum, IProduct } from "@/models/product.entity";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { PartnerModule } from "@/store/modules/partner";
import { ProductModule } from "@/store/modules/product.store";
import { debounce } from "debounce";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import Tooltip from "../utility/tooltip.vue";

type ObjectType = Pick<
  IRepairEstimate | IInvoice,
  "currency" | "totalGross" | "totalNet" | "taxRates" | "calcItemsPerTaxRate"
>;

export type ExtendedLineItem = IInvoiceLine & {
  search?: string | null;
  isLoading?: boolean | null;
  product?: IProduct | string | null;
};
export type ExtendedLineItems = { lineItems: ExtendedLineItem[] };

export type ObjectWithLineItemType = ObjectType & ExtendedLineItems;

@Component({
  components: {
    Tooltip
  },
  filters: {}
})
export default class LineItemsForm extends mixins(PermissionMixin, RulesMixin) {
  readonly formatCurrency = formatCurrency;

  @Prop()
  value!: ObjectWithLineItemType;

  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  @Prop({ type: Boolean, default: true })
  showProducts!: boolean;

  @Prop({ type: Boolean, default: true })
  showQuantity!: boolean;

  @Prop({ type: Boolean, default: true })
  showTax!: boolean;

  @Prop({ type: Boolean, default: true })
  showAdd!: boolean;

  @Prop({ type: Boolean, default: true })
  showRemove!: boolean;

  @Prop()
  accountingType?: AccountingTypeEnum;

  debounceTimeout = 300;

  debouncedProductSearch = debounce(
    (search: string, item?: ExtendedLineItem) => this.searchProduct(search, item),
    this.debounceTimeout
  );

  async searchProduct(search: string, item?: ExtendedLineItem) {
    if (!item || !search) {
      return;
    }

    item.search = search;
    item.isLoading = true;

    try {
      ProductModule.setSearch(item.search);
      await ProductModule.fetchPage({ partnerId: this.partner.id });
    } catch (e) {
      handleError(e);
    } finally {
      item.isLoading = false;
    }
  }

  get md() {
    // 12 cols - 6 for title
    const md = 12 - 6;
    const showAmount = true;
    const numberOfShowed = Number(showAmount) + Number(this.showQuantity) + Number(this.showTax);

    return Math.floor(md / numberOfShowed);
  }

  get cols() {
    return 4;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get taxRates() {
    return this.showTax ? this.partner.settings?.taxRates : [];
  }

  get products() {
    return ProductModule.entities;
  }

  get hasItems() {
    return ProductModule.totalItems > 0;
  }

  addInvoiceLine(li: IInvoiceLine = new InvoiceLine()) {
    this.value.lineItems.push(li);
  }

  onProductInput(lineItem: ExtendedLineItem, e: IProduct) {
    this.$log.debug(lineItem, e);
    lineItem.product = e;
    this.addAsLineItem(lineItem);
  }

  addAsLineItem(lineItem: ExtendedLineItem) {
    if (!lineItem || !lineItem.product) {
      return;
    }

    this.$log.debug(lineItem);

    const productLineItem = lineItem.product as IProduct;
    if (productLineItem.title) {
      lineItem.setFromProduct(productLineItem, this.accountingType);
    } else {
      lineItem.title = lineItem.product as string;
    }
  }

  removeInvoiceLine(index: number) {
    this.value.lineItems.splice(index, 1);
  }
}
